var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMap = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M26 12c0-6.089-4.172-10-10-10S6 5.911 6 12c0 4.193 3.315 10.068 10 17.512C22.685 22.068 26 16.192 26 12M4 12C4 4.777 9.095 0 16 0s12 4.777 12 12c0 4.905-3.649 11.288-10.89 19.266a1.5 1.5 0 0 1-2.118.103c-.053-.05-.053-.05-.103-.103C7.65 23.288 4 16.906 4 12m12 4a5 5 0 1 1 0-10 5 5 0 0 1 0 10m0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6"
})));
export default SvgMap;